import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { confirmForceEditTicket } from '../handler/DetailTicketHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const ConfirmForceEditTicket = props => {
    useTranslationSubscription();
    const isOpen = props.forceEditTicketObject?.method > 0 ? true : false;

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setForceEditTicketObject({
            method: 0,
            requestDto: {}
        });
        props.setTriggerReloadTicket(Date.now().toString());
        props.reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST });
        props.setIsEdited(false)
        props?.setListFieldEdited([])
    };

    const onSubmitForceEditTicket = () => {
        confirmForceEditTicket(
            props,
            Constant.UPDATE_TICKET_METHOD.FORCE_EDIT_ASSIGNEE_AND_STATUS,
            props.forceEditTicketObject.requestDto
        );

        props.setForceEditTicketObject({
            method: 0,
            requestDto: {}
        });
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {trI18n('USER04MSG024')}
                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={onSubmitForceEditTicket}
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
